const documentLevelCollator = new Intl.Collator('de', {
  numeric: true,
  sensitivity: 'base'
});

const numericDocumentLevel = (entry) => {
  const value = entry?.document_level_number;
  if (value === null || value === undefined || value === '') return null;

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export function taiwanParagraphTitle(entry) {
  const description = String(entry?.document_level_description ?? '').trim().toLowerCase();
  const number = String(entry?.document_level_number ?? '').trim();

  if (description !== 'paragraph' || !number) return null;

  return `Art. ${number}`;
}

export function compareStandardTextsByDocumentLevel(a, b) {
  const aNumber = numericDocumentLevel(a);
  const bNumber = numericDocumentLevel(b);

  if (aNumber === null && bNumber !== null) return 1;
  if (aNumber !== null && bNumber === null) return -1;
  if (aNumber !== null && bNumber !== null && aNumber !== bNumber) {
    return aNumber - bNumber;
  }

  const levelComparison = documentLevelCollator.compare(
    String(a?.document_level ?? ''),
    String(b?.document_level ?? '')
  );
  if (levelComparison !== 0) return levelComparison;

  const aId = Number(a?.id);
  const bId = Number(b?.id);
  if (Number.isFinite(aId) && Number.isFinite(bId)) return aId - bId;

  return documentLevelCollator.compare(String(a?.id ?? ''), String(b?.id ?? ''));
}
